<template>
    <div>
        <template v-if="props.result.QuantityOnHand">
            <div v-if="props.isBasic">{{ inStockMessage }}</div>
            <div v-else class="text-base font-bold whitespace-nowrap">
                <span>{{ quantityOnHandLabel }}</span>
                <span class="text-success mx-1">{{ $t("Global.InStock") }}</span>
                <Icon name="check" />
            </div>
        </template>
        <div v-for="message in stockMessages" :key="message">{{ message }}</div>
        <div v-if="factoryLeadTimeMessage">{{ factoryLeadTimeMessage }}</div>
        <Badge v-if="props.result.QuantityOnHand && props.result.IsDuplicateStock" fill="light" class="mt-1">
            *{{ $t("Search.DuplicateStock") }}
        </Badge>
        <div v-if="isOutOfStock" class="out-of-stock-label">{{ $t("Global.OutOfStock") }}</div>
    </div>
</template>
<script setup lang="ts">
const { getStockMessages, getLeadTimeMessage, partHasAnyStock } = usePartStock();
const { t } = useI18n();

const props = defineProps<{ result: Partial<PartResult>; isBasic?: boolean }>();

const stockMessages = computed(() => getStockMessages(props.result));

const quantityOnHandLabel = computed(
    () => formatNumber(props.result.QuantityOnHand) + (props.result.IsDuplicateStock ? "*" : "")
);

const inStockMessage = computed(() => {
    let message = t("Search.QuantityInStock", [formatNumber(props.result.QuantityOnHand)]);
    if (props.result.IsDuplicateStock) message += "*";

    return message;
});

const factoryLeadTimeMessage = computed(() => getLeadTimeMessage(props.result));

const isOutOfStock = computed(() => !partHasAnyStock(props.result));
</script>
